var map = {
	"./3d-assistant.png": 87,
	"./astro-amateur-new.png": 353,
	"./astro-amateur.png": 809,
	"./budget-tracker.png": 132,
	"./destroy-the-moon.png": 429,
	"./fresh-finds.png": 788,
	"./newna-bros.png": 931,
	"./notetaker.png": 623,
	"./reading-corner.png": 258,
	"./social-media-api.png": 172,
	"./tech-blog.png": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 840;